import classNames from 'classnames';
import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef } from 'react';
import ShimmerImage from 'core-lib/components/ShimmerImage';
import { Typography } from 'ui-v2/components/Typography';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import useStoreItemClick from '../../../hooks/useStoreItemClick';
import { LayoutEntityType, LayoutPropType } from '../../../types/layout';
import Product from '../../../types/product';
import { trackSectionViewedStoreV2 } from '../../../utils/events';
import s from './GridSaleListing.module.scss';

type PropType = {
  products: Product[];
  listingOrder: number[];
  entityType: LayoutEntityType;
  section?: string;
};
const DisplayItem = ({ products, entityType, section }: PropType) => {
  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = entityType;

  const cardClasses = [`${s.item1}`, `${s.item2}`, `${s.item3}`, `${s.item4}`];

  return (
    <div
      className={s.gridContainer}
      onClick={(e) => {
        handleItemClickWithDelegation(e, CARDID, entityType, products, section);
      }}
    >
      {products.map((product, index) => (
        <div
          className={classNames(
            s.gridItem,
            'cmn_touchable_area',
            cardClasses[index % cardClasses.length]
          )}
          key={index}
          id={CARDID}
          data-index={index}
        >
          <ShimmerImage src={product?.coverImage} className={s.image} />
        </div>
      ))}
    </div>
  );
};

export const GridSaleListing = ({ data }: LayoutPropType) => {
  //constant
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(data?.title || data?.sectionName);
      isEventFired.current = true;
    }
  }, [data?.sectionName, data?.title, inViewPort]);

  if (!data?.data?.length && !data?.metaData?.listingOrder.length) {
    return null;
  }

  return (
    <div
      className={s.root}
      ref={rootRef}
      style={
        data?.backgroundImage
          ? {
            backgroundImage: `url(${data.backgroundImage})`,
          }
          : {}
      }
    >
      <Typography label={data?.title} variant="h_3_medium" className={s.title} />
      {data?.metaData?.headingImage && (
        <div className={s.iconWrapper}>
          <AnimatedImage
            src={data?.metaData?.headingImage}
            className={s.heading}
            alt='headingImage'
          />
        </div>
      )}
      <DisplayItem
        products={data?.data}
        listingOrder={data?.metaData?.listingOrder}
        section={data?.title}
        entityType={data?.entityType}
      />
    </div>
  );
};
